<template>
    <div  v-bind:class="{'notedited': !device_category['edit'] , 'collapsible-body': device_category['id']}">
        <div class="row" style="width: 100%;">
            <div class="col s2 rightlabel">
                {{$t('device_categories.name')}}
            </div><div class="col s3"><div class="input-field"><input :id="'dcname'+(device_category.id || 'new')" type="text" :placeholder="$t('device_categories.name_placeholder')" v-model="device_category.name" :disabled="device_category.edit == false" /></div>
            </div>
             <div class="col s2 offset-s1 label">
                 {{$t('device_categories.prefix')}}
                 <div class="input-field inline" style="width: 5em;"><input :id="'dcprefix'+(device_category.id || 'new')" type="text" :placeholder="$t('device_categories.prefix')" v-model="device_category.prefix" :disabled="device_category.edit == false" />
             </div>
         </div>
              <div class="col s3 label">
                 {{$t('device_categories.color')}}
                 <div class="input-field inline"><input :id="'dccolor'+(device_category.id || 'new')" type="color" :placeholder="$t('device_categories.color_placeholder')" v-model="device_category.graph_color" :disabled="device_category.edit == false" />
             </div>
         </div>
            <div class="col s1" v-if="device_category.editable">
              <a class="waves-effect waves-light btn-small red"  v-bind:class="{'opaquebutton': (device_category.total > 0)}" v-on:click="remove(device_category)"  v-if="hasRemoveListener"  v-bind:title="deleteTitle">{{$t('menu.buttons.delete')}}</a>
            </div>
        </div>
        <div class="row" style="width: 100%;">
            <div class="col offset-s1 s2 rightlabel">
                {{$t('device_categories.substances')}}
            </div>
            <div class="col s4">
                <selector v-model="device_category.substance_ids" :items="substances" :identifier="'substancesfordc'+device_category.id"  :disabled="device_category.edit == false" :elongating="true"></selector>
            </div>
        </div>
        <div class="row" style="width: 100%;">
            <div class="col s3 rightlabel">
                {{$t('device_categories.measurement_method')}}
            </div>
            <div class="col s4" style="padding-right: 4px;">
                <select :id="'dccritmethod'+(device_category.id || 'new')" v-model="device_category.criterium.method" :disabled="device_category.edit == false">
                    <option value="standard">{{$t('devices.standard')}}</option>
                    <option value="pests_quantity">{{$t('devices.pest_amount')}}</option>
                    <option value="substance_consumed">{{$t('devices.substance_consumed')}}</option>
                    <option value="logic_value">{{$t('devices.logic_value')}}</option>
                </select>
            </div>
        </div>
                <template v-if="device_category.criterium">
        <div class="row grey" style="width: 100%; padding: 15px 0px;">
            <div class="col s2">
                {{$t('devices.no_activity')}}  <br/>({{$t('routine_analyses.zero_points')}})
            </div>
             <div class="col s2">
                {{$t('devices.low_activity')}} <br/> ({{$t('routine_analyses.one_point')}})
            </div>
             <div class="col s2">
                {{$t('devices.average_activity')}} <br/> ({{$t('routine_analyses.two_points')}})
            </div>
             <div class="col s2">
                {{$t('devices.high_activity')}} <br/>({{$t('routine_analyses.three_points')}})
            </div>
             <div class="col s2">
                {{$t('devices.very_high_activity')}}<br/>({{$t('routine_analyses.four_points')}})
            </div>
            <div class="col s1">
                {{$t('devices.critical_point')}}
            </div>
        </div>
        <div class="row grey" style="width: 100%;" v-if="device_category.criterium.method == 'standard'">
            <div class="col s2 input-field inline">
                <input :id="'dccritno_activity_text'+(device_category.id || 'new')" v-model="device_category.criterium.no_activity_text"/>
            </div>
             <div class="col s2 input-field inline">
                <input :id="'dccritlow_activity_text'+(device_category.id || 'new')" v-model="device_category.criterium.low_activity_text"/>
            </div>
             <div class="col s2 input-field inline">
                <input :id="'dccritmedium_activity_text'+(device_category.id || 'new')" v-model="device_category.criterium.medium_activity_text"/>
            </div>
             <div class="col s2 input-field inline">
                <input :id="'dccrithigh_activity_text'+(device_category.id || 'new')" v-model="device_category.criterium.high_activity_text"/>
            </div>
             <div class="col s2 input-field inline">
                <input :id="'dccritvery_high_activity_text'+(device_category.id || 'new')" v-model="device_category.criterium.very_high_activity_text"/>
            </div>
            <div class="col s1 input-field inline">
                <input :id="'dccritcritical_point'+(device_category.id || 'new')" v-model="device_category.criterium.critical_point" max="4" min="0" step=".1" type="number"/>
            </div>
        </div>
        <template v-if="device_category.criterium.method == 'pests_quantity'">
         <div class="row grey" style="width: 100%;" >
                      <div class="col s2 input-field inline">
                <input value="0" type="number" style="width: 47px;" disabled=""> szt.
            </div>
             <div class="col s2 input-field inline">
                <input value="1" type="number" style="width: 47px;" disabled="">  &#8212; 
                <input v-model="device_category.criterium.medium_activity_thresold" @change="criteriumChanged(device_category.criterium)" type="number" style="width: 47px;"/> szt.
            </div>
            <div class="col s2 input-field"><input :value="parseInt(device_category.criterium.medium_activity_thresold, 10) + 1" type="number" style="width: 47px;" disabled="">   &#8212;
                <input v-model="device_category.criterium.high_activity_thresold" @change="criteriumChanged(device_category.criterium)" type="number"  style="width: 47px;/> szt."/>
            </div>
             <div class="col s2 input-field">
              <input :value="parseInt(device_category.criterium.high_activity_thresold, 10) + 1" type="number" style="width: 47px;" disabled="">  &#8212;
                <input v-model="device_category.criterium.very_high_activity_thresold" @change="veryHighCriteriumChanged(device_category.criterium)" type="number"  style="width: 47px;"/> szt.
            </div>
             <div class="col s2 input-field inline">
                {{$t('devices.over')}} <input v-model="device_category.criterium.very_high_activity_thresold" type="number"  style="width: 47px;" disabled="" /> szt.
            </div>
            <div class="col s1 input-field inline">
                <input v-model="device_category.criterium.critical_point" max="4" min="0" step=".1" type="number"/>
            </div>
        </div>
        <div class="row " style="width: 100%; line-height: 2; margin-top: 15px;">
          <div class="col s12" v-if="device_category.criterium.pests_thresolds != undefined &&  device_category.criterium.pests_thresolds.length > 0">
            {{$t('devices.target_pests')}}:
          </div>
        </div>
        <template v-for="pt in device_category.criterium.pests_thresolds" v-if="pt.destroy != true">
        <div class="row grey tabel" style="width: 100%; margin-top: 15px; padding-top: 5px;">
          <div class="col s1">{{$t('devices.pest')}}</div>
          <div class="col s3">
          <select v-model="pt.pest_id">
            <option v-for="pest in pests" :value="pest.id">{{pest.name}}</option>
        </select>
        </div>
         <div class="col s3"><a class="btn btn-small red" v-on:click="removeTargetPest(device_category.criterium, pt)">{{$t('menu.buttons.delete')}}{{pt.destroy}}</a></div>
      </div>
      <div class="row grey" style="width: 100%;  ">
        <div class="col s2">
                 {{$t('devices.no_activity')}} ({{$t('routine_analyses.zero_points')}})
            </div>
             <div class="col s2">
              {{$t('devices.low_activity')}} ({{$t('routine_analyses.one_point')}})
            </div>
             <div class="col s2">
                {{$t('devices.average_activity')}} ({{$t('routine_analyses.two_points')}})
            </div>
             <div class="col s2">
                {{$t('devices.high_activity')}} ({{$t('routine_analyses.three_points')}})
            </div>
             <div class="col s2">
                {{$t('devices.very_high_activity')}} ({{$t('routine_analyses.four_points')}})
            </div>
            <div class="col s2">
                {{$t('devices.critical_point')}}
            </div>
          </div>
          <div class="row grey tabel" style="width: 100%; margin-bottom: 15px;">
             <div class="col s2">
                {{$t('devices.no_pest')}}
            </div>
             <div class="col s2 input-field"> 1 szt.  &#8212; 
                 <input v-model="pt.medium_activity_thresold" type="number"  @change="criteriumChanged(device_category.criterium[devc.id])" style="width: 47px;"/> szt.
            </div>
             <div class="col s2 input-field">
                {{parseInt(pt.medium_activity_thresold, 10) + 1}} &#8212;   <input v-model="pt.high_activity_thresold" type="number"  @change="criteriumChanged(device_category.criterium[devc.id])"  style="width: 47px;"/> szt.
            </div>
             <div class="col s2 input-field">
               {{parseInt(pt.high_activity_thresold, 10) + 1}}  &#8212;   <input v-model="pt.very_high_activity_thresold" type="number"  @change="veryHighCriteriumChanged(device_category.criterium[devc.id])" style="width: 47px;"/> szt.
            </div>
             <div class="col s2 input-field">
                {{$t('devices.above')}} {{parseInt(pt.very_high_activity_thresold, 10) + 1}} szt.
            </div>
              <div class="col s1 input-field inline">
                <input v-model="pt.critical_point" max="4" min="0" step=".1" type="number"/>
            </div>
          </div>
        </template>
      </template>
        <div class="row grey tabel" style="width: 100%;" v-if="device_category.criterium.method == 'substance_consumed'">

              <div class="col s2 input-field ">
                0 %
            </div>
             <div class="col s2 input-field ">
               1  &#8212;
                <input  type="number" v-model="device_category.criterium.medium_activity_thresold" min="1" max="99"  @change="criteriumChanged(device_category.criterium)" style="width: 47px;"/> %
            </div>
             <div class="col s2 input-field ">
                {{parseInt(device_category.criterium.medium_activity_thresold) + 1}} &#8212;
                <input  type="number" v-model="device_category.criterium.high_activity_thresold" min="1" max="99"  @change="criteriumChanged(device_category.criterium)" style="width: 47px;"/>
             </div>
             <div class="col s2 input-field ">
                {{parseInt(device_category.criterium.high_activity_thresold) + 1}} &#8212;
                <input  type="number" v-model="device_category.criterium.very_high_activity_thresold" min="1" max="99"  @change="veryHighCriteriumChanged(device_category.criterium)" style="width: 47px;"/>
            </div>
            <div class="col s2 input-field">
              {{parseInt(device_category.criterium.very_high_activity_thresold, 10) + 1}} &#8212; 100%</div>
            <div class="col s1 input-field">
                <input v-model="device_category.criterium.critical_point" max="4" min="0" step=".1" type="number"/>
            </div>
        </div>
        <div class="row grey" style="width: 100%;" v-if="device_category.criterium.method == 'logic_value'">
            <div class="col s2 input-field inline">
                <input v-model="device_category.criterium.no_activity_text"/>
            </div>
             <div class="col s2 input-field inline">
                
            </div>
             <div class="col s2 input-field inline">
                
            </div>
              <div class="col s2 input-field inline">
                
            </div>
             <div class="col s2 input-field inline">
                 <input v-model="device_category.criterium.high_activity_text"/>
            </div>
               <div class="col s2 input-field inline">
                
            </div>
            <div class="col s1 input-field inline">
                <input v-model="device_category.criterium.critical_point" max="4" min="0" step=".1" type="number"/>
            </div>
        </div>
        </template>
        <div class="row" style="margin-top: 16px;" v-if="device_category.editable">
            <div class="col offset-l10 s4 l2" v-if="device_category.edit == false" style="text-align: right;"><a class="waves-effect waves-light btn-large emptygreen" v-on:click="editDevType(device_category)" v-if="device_category.edit == false">{{$t('menu.buttons.edit')}}</a></div>
            <div class="col  offset-l8 s4 l2" v-if="device_category.edit" style="text-align: right;"><a class="waves-effect waves-light btn-large cancelbutton" v-on:click="unEditDevType(device_category)" v-if="device_category.edit"> {{$t('menu.buttons.cancel_changes')}}</a></div>
            <div class="col l2 s4" v-if="device_category.edit" style="text-align: right; "><a style="width: 100%;" class="waves-effect waves-light btn-large emptygreen" v-on:click="saveDevType(device_category)" v-if="device_category.edit">
                    <div v-if="saving" class="preloader-wrapper small active">
                        <div class="spinner-layer spinner-red-only">
                            <div class="circle-clipper left">
                                <div class="circle"></div>
                            </div>
                            <div class="gap-patch">
                                <div class="circle"></div>
                            </div>
                            <div class="circle-clipper right">
                                <div class="circle"></div>
                            </div>
                        </div>
                    </div>
                    {{saving == false ? $t('menu.buttons.save_changes') : ""}}
                </a></div>
        </div>
    </div>
</template>
<script>
import axios from 'axios';
export default {
    data: function() {
        return {
            order: 1,
            orderby: 'number',
            customers: [],
            saving: false
        }
    },
    props: {  substances: Array, device_category: Object },
    created() {
    },
    methods: {

        collapse: function(customer) {
            customer.collapsed = !(customer.collapsed);
            this.$forceUpdate();
        },
        set_order: function(order) {
            if (this.orderby == order) {
                if (this.order == 1) {
                    this.order = 0
                } else if (this.order == 0) {
                    this.order = 1
                }

            } else {
                this.orderby = order;
            }
        },
        remove: function(){
            if(this.device_category.total > 0) return 0;
            this.$emit('removeDeviceCategory', this.device_category)
        },
        editDevType: function(device_category) {
            device_category.edit = true;
            this.$forceUpdate();
        },
        unEditDevType: function(device_category, rd) {
            if(device_category.id != undefined && rd != undefined){
                if(device_category.criterium != undefined){
                    device_category.criterium.id = rd.criterium.id;
                }
                device_category.edit = false;
                this.$forceUpdate();
            }else{
                device_category.edit = false;
                this.$forceUpdate();
                this.$emit('cancelDeviceCategory')
            }
        },
        saveDevType: function(device_category) {
            if (_.isUndefined(device_category.id)) {
                axios.post('/device_categories.json', { device_category: device_category }).then(response => {
                    this.device_category.id = response.data.id;
                    this.$emit('addedDeviceCategory', this.device_category)
                    this.unEditDevType(device_category);
                });
            } else {
                this.device_category['criterium_attributes'] =  this.device_category['criterium']
                axios.put('/device_categories/' + device_category.id + '.json', { device_category: device_category }).then(response => {
                    this.unEditDevType(device_category, response.data);
                });
            }
        },
        criteriumChanged(crit){
          if(crit.method == 'substance_consumed' && crit.very_high_activity_thresold >= 99){
            crit.very_high_activity_thresold = 98;
          }
          if(crit.medium_activity_thresold >= (parseInt(crit.high_activity_thresold) - 1)){
            crit.high_activity_thresold = parseInt(crit.medium_activity_thresold) + 2;
          }
          if(crit.high_activity_thresold >= (parseInt(crit.very_high_activity_thresold) - 1)){
            crit.very_high_activity_thresold = parseInt(crit.high_activity_thresold) + 2;
          }
        },
        veryHighCriteriumChanged(crit){
          if(crit.method == 'substance_consumed' && crit.very_high_activity_thresold >= 99){
            crit.very_high_activity_thresold = 98;
          }else if(crit.medium_activity_thresold >= (parseInt(crit.high_activity_thresold) - 1)){
            crit.high_activity_thresold = parseInt(crit.medium_activity_thresold) + 2;
          }else if(crit.high_activity_thresold >= (parseInt(crit.very_high_activity_thresold) - 1)){
            crit.very_high_activity_thresold = parseInt(crit.high_activity_thresold) + 2;
          }else{
          }
        },
    },
    computed: {
        hasRemoveListener(){
            return this.$listeners && this.$listeners.removeDeviceCategory
        },
        deleteTitle() {
          if (this.device_category.total > 0) {
            return this.$t('device_categories.delete_disabled', {
              n: this.device_category.total
            })
          }  

          return this.$t('menu.buttons.delete')
        }
    }

}
</script>
<style scoped>
.login_button {
    color: red;
}

p {
    font-size: 2em;
    text-align: center;
}

nav {
    background-color: #626262;
    height: 100px;
}

nav a {
    margin: 15px;
}

.settingsform .btn-large {
    border-radius: 8px;
    background-color: white;
    color: black;
    border-color: #00CC66;
    border-width: 1px;
    border-style: solid;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.solidgreen {
   background-color: #00CC66 !important;
}
.btn-small {
    color: black;
    border-radius: 8px;
}

.red {
    background-color: #C22026 !important;
    border-color: #C22026 !important;
}
select{
  display: block;
  background-color: white !important;
  border-radius: 4px !important;
  border-width: 1px !important;
  border-style: solid !important;
  border-color: rgb(140, 140, 140) !important;
  padding-left: 5px !important;
  height: 35px !important;
}
.inline input{
    margin-bottom: 5px;
}
.opaquebutton {
    opacity: 0.5;
}
</style>